var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt10 text-center"},[_c('el-button',{on:{"click":_vm.handleLast}},[_vm._v("上一步")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleSumbit}},[_vm._v(" 确定无误，我要提交 ")])],1),_c('div',{staticClass:"mt20"},[_c('panel',{ref:"Panel"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }